export const sxConfig = {
  caption: {
    fontSize: '1.1rem',
    fontWeight: 'bold',
  },
};
